import { Link, LinkProps } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { buildLocalizedPath } from "@/i18n/detectLanguage";

/**
 * A Link component that automatically prefixes the `to` path
 * with the current language in prefix mode.
 */
interface LocalizedLinkProps extends Omit<LinkProps, "to"> {
  to: string;
}

const LocalizedLink = ({ to, ...props }: LocalizedLinkProps) => {
  const { i18n } = useTranslation();
  const localizedTo = buildLocalizedPath(to, i18n.language);
  return <Link to={localizedTo} {...props} />;
};

export default LocalizedLink;
